/**
 * External Dependencies
 */
// import 'jquery';
import menuDropdown from './components/_menuDropdown';
import animations from './components/_animations';
import hamburger from './components/_hamburger';
import header from './components/_header';
import hideNav from './components/_hideNav';
import gravityForms from './components/_gravityForms';
import woocommercePage from './components/_woocommercePage';

animations();
menuDropdown();

window.addEventListener('DOMContentLoaded', () => {
  hamburger;
  header;
  gravityForms;

  if (document.body.classList.contains('hide-nav')) {
    hideNav;
  }
  if (document.body.classList.contains('woocommerce-page')) {
    woocommercePage;
  }
});
